<child-onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="store.sendingNationalityTaxInformation$ | async"
  (back)="service.goToPreviousStep()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'child-onboarding.nationality.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'child-onboarding.nationality.text' | transloco }}</p>
  <web-design-system-select
    [items]="nationalities$ | async"
    [placeholder]="'child-onboarding.nationality.headline' | transloco"
    (selectItem)="selectNationality($event)"
  />
  <p class="zero-text p-huge-med mt-5">{{ 'child-onboarding.nationality.tax.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">
    <span class="zero-text p-base-med">{{ 'child-onboarding.nationality.tax.tax-label' | transloco }}:</span>
    {{ 'child-onboarding.nationality.tax.tax-germany' | transloco }}
    <web-design-system-icon
      class="cursor-pointer"
      name="info"
      color="dimmed"
      [ngbTooltip]="'child-onboarding.nationality.tax.tax-hint' | transloco"
      tooltipClass="zero-tooltip"
      placement="bottom"
      triggers="hover click"
    />
  </p>
  @if (taxCountry$ | async; as taxCountry) {
    <div class="mt-3 zero-text p-small-reg">
      {{ 'child-onboarding.nationality.tax.acceptance' | transloco }}
      <ng-container *ngTemplateOutlet="baaderBankTooltip" />
      {{ 'child-onboarding.nationality.tax.independently.text' | transloco }}
      <br />
      {{ 'child-onboarding.nationality.tax.independently.pre' | transloco }}
    </div>
    <web-design-system-input
      class="d-block mt-3"
      [label]="'child-onboarding.nationality.tax.tin' | transloco"
      [value]="tin$ | async"
      [isValid]="tin$ | async | tin: taxCountry"
      [error]="tin$ | async | tinError: taxCountry"
      (valueChange)="handleTinChange($event)"
    />
  }
</child-onboarding-container>

<ng-template #baaderBankTooltip>
  <span
    class="text-underline-dotted"
    [ngbTooltip]="'child-onboarding.nationality.tax.baader-bank.tooltip' | transloco"
    triggers="hover click"
    tooltipClass="zero-tooltip"
    placement="bottom"
  >
    {{ 'child-onboarding.nationality.tax.baader-bank.label' | transloco }}
  </span>
</ng-template>
